import script from "./HotCourseComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HotCourseComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HotCourseComponent.vue?vue&type=style&index=0&id=37d8241a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d8241a"]])

export default __exports__